import React from 'react';
import logo from 'parmasottositi-theme/components/Logo/logo.png';

const Logo = () => (
  <figure className="header-logo">
    <img src={logo} alt="" width="87" height="86" />
  </figure>
);

export default Logo;
